import { Box, Container, Grid, Skeleton, Typography } from "@mui/material";
import Layout from "@/components/Layout";
import { useRecoilValue } from "recoil";
import { activeRegionAtom } from "@/atoms/activeRegion";
import { unitSystemAtom } from "@/atoms/units";
import { useRegion } from "@/hooks/useRegions";
import TideCard from "./TideCard";
import WeatherCard from "./WeatherCard";

export default function SurfDashboard() {
  const activeRegion = useRecoilValue(activeRegionAtom);
  const units = useRecoilValue(unitSystemAtom);
  const { data: regionData, isLoading } = useRegion(activeRegion);

  const firstBreak = regionData?.breaks?.[0];

  if (isLoading || !firstBreak) {
    return (
      <Layout>
        <Container maxWidth="lg" sx={{ py: 3 }}>
          <Skeleton variant="text" width={300} height={48} sx={{ mx: "auto", mb: 3 }} />
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Skeleton variant="rounded" height={200} />
            </Grid>
            <Grid item xs={12} md={6}>
              <Skeleton variant="rounded" height={200} />
            </Grid>
          </Grid>
        </Container>
      </Layout>
    );
  }

  const lat = firstBreak.lat;
  const lon = firstBreak.lon;
  const label = regionData?.label ?? firstBreak.name;

  return (
    <Layout>
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 800,
            mb: 3,
            textAlign: "center",
          }}
        >
          {label} Surf Forecast
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TideCard lat={lat} lon={lon} label={label} region={activeRegion} />
          </Grid>
          <Grid item xs={12} md={6}>
            <WeatherCard lat={lat} lon={lon} label={label} units={units} />
          </Grid>
        </Grid>

        <Box sx={{ mt: 4, textAlign: "center" }}>
          <Typography variant="body2" color="text.secondary">
            Weather from Open-Meteo
          </Typography>
        </Box>
      </Container>
    </Layout>
  );
}
